import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axiosInstance";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import './css/Inscripciones.css'

function CrearInscripcion() {
  const navegar = useNavigate();
  const navigate = useNavigate();

  const [eventos, setEventos] = useState([]);
  const [formulario, setFormulario] = useState({
    nombre: '',
    apellidos: '',
    dni: '',
    fecha_nacimiento: '',
    fecha_inscripcion: '',
    nombre_tutor: '',
    apellidos_tutor: '',
    direccion: '',
    telefono_tutor: '',
    sexo: '',
    autoriza_img: false,
    evento_id: '',
    user_id: '', // Se establece dinámicamente
  });

  // Al cargar el componente, establecemos el user_id automáticamente
  useEffect(() => {
    const usuario = sessionStorage.getItem('user');
    if (usuario) {
      const { id } = JSON.parse(usuario); // Obtenemos el ID del usuario
      setFormulario(prev => ({ ...prev, user_id: id }));
    }
  }, []);

  useEffect(() => {
    const obtenerEventos = async () => {
      try {
        const respuesta = await axios.get("https://intranet-api.coloniasdetiscar.es/api/eventos");
        setEventos(respuesta.data);
      } catch (error) {
        console.error("Error al obtener eventos:", error);
      }
    };
    obtenerEventos();
  }, []);

  const manejarCambio = (e) => {
    const { name, value, type, checked } = e.target;
    setFormulario({
      ...formulario,
      [name]: type === "checkbox" ? (checked ? true : false) : value,
    });
  };

  const volver = () => {
    navigate(-1); 
  };

  const crearNuevaInscripcion = async (e) => {
    e.preventDefault();
    try {
      await axios.post(process.env.REACT_APP_BACKEND_URL + '/api/inscripciones', formulario);
      alert("Inscripción creada correctamente");
      navegar('/inscripcionUser');
    } catch (error) {
      if (error.response?.status === 422) {
        alert("Errores de validación: " + JSON.stringify(error.response.data.errors));
      } else {
        console.error("Error al crear la inscripción:", error);
        alert("Error inesperado al crear la inscripción");
      }
    }
  };

  return (
    <Container className="contenedorEventos p-4">
      <Button className="boton_accion" size="sm" onClick={volver}>⬅ Volver</Button>
      <h2 className="tituloEvento mb-4">Crear Nueva Inscripción</h2>
      <Form onSubmit={crearNuevaInscripcion}>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Nombre</Form.Label>
              <Form.Control type="text" name="nombre" value={formulario.nombre} onChange={manejarCambio} required />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Apellidos</Form.Label>
              <Form.Control type="text" name="apellidos" value={formulario.apellidos} onChange={manejarCambio} required />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>DNI</Form.Label>
              <Form.Control type="text" name="dni" value={formulario.dni} onChange={manejarCambio} required />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Fecha de Nacimiento</Form.Label>
              <Form.Control type="date" name="fecha_nacimiento" value={formulario.fecha_nacimiento} onChange={manejarCambio} required />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Fecha de Inscripción</Form.Label>
              <Form.Control type="date" name="fecha_inscripcion" value={formulario.fecha_inscripcion} onChange={manejarCambio} required />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Teléfono del Tutor</Form.Label>
              <Form.Control type="text" name="telefono_tutor" value={formulario.telefono_tutor} onChange={manejarCambio} />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Nombre del Tutor</Form.Label>
              <Form.Control type="text" name="nombre_tutor" value={formulario.nombre_tutor} onChange={manejarCambio} />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Apellidos del Tutor</Form.Label>
              <Form.Control type="text" name="apellidos_tutor" value={formulario.apellidos_tutor} onChange={manejarCambio} />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Dirección</Form.Label>
          <Form.Control type="text" name="direccion" value={formulario.direccion} onChange={manejarCambio} />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Sexo</Form.Label>
          <Form.Select name="sexo" value={formulario.sexo} onChange={manejarCambio}>
            <option value="">Seleccione</option>
            <option value="Hombre">Hombre</option>
            <option value="Mujer">Mujer</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check
            type="checkbox"
            label="Autoriza uso de imágenes"
            name="autoriza_img"
            checked={formulario.autoriza_img == true}
            onChange={manejarCambio}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Evento</Form.Label>
          <Form.Select name="evento_id" value={formulario.evento_id} onChange={manejarCambio} required>
            <option value="">Seleccione un evento</option>
            {eventos.map(evento => (
              <option key={evento.evento_id} value={evento.evento_id}>
                {evento.nombre} ({evento.fecha_inicio} - {evento.fecha_fin})
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {/* Campo oculto para user_id */}
        <Form.Control type="hidden" name="user_id" value={formulario.user_id} readOnly />

        <Button className="boton_accion w-100" type="submit">
          Crear Inscripción
        </Button>
      </Form>
    </Container>
  );
}

export default CrearInscripcion;

